__turbopack_context__.v({
  "btn": "CheckoutConfirmPopup-module-scss-module__zoS4Da__btn",
  "btnContinue": "CheckoutConfirmPopup-module-scss-module__zoS4Da__btnContinue",
  "btnGoBack": "CheckoutConfirmPopup-module-scss-module__zoS4Da__btnGoBack",
  "footer": "CheckoutConfirmPopup-module-scss-module__zoS4Da__footer",
  "root": "CheckoutConfirmPopup-module-scss-module__zoS4Da__root",
});
